import { Modal } from "@mui/material";
import React from "react";
import Styles from "./ViewDrawalModal.module.css";
import { Close } from "@mui/icons-material";

const ViewDrawalModal = ({ open, handleClose, data }) => {
  // Helper function to display time in UI (converts 23:59 to 24:00)
  const displayTime = (time) => {
    if (!time) return "—";
    if (time === "23:59") return "24:00";
    return time;
  };
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="child-modal-title"
        aria-describedby="child-modal-description"
      >
        <div className={`popupModal ${Styles.createEditModalCont}`}>
          <div
            className={`display_flex_row modalHeading ${Styles.modalHeading}`}
          >
            <div className="headingText">View Drawal Details</div>
            <Close
              style={{ fontSize: "24px", color: "#777777", cursor: "pointer" }}
              onClick={handleClose}
            />
          </div>
          <div className={Styles.injectionTableArea}>
            <div className={Styles.tableContentInject}>
              <div className={Styles.injectHeader}>
                <div>Start Date</div>
                <div>End Date</div>
                <div>Start Time</div>
                <div>End Time</div>
                <div>Quantity (MW)</div>
              </div>
              <div className={`scroll_bar_y ${Styles.tableContentElements}`}>
                {data?.map((item, index) => (
                  <div key={index} className={Styles.injectTableContent}>
                    <div>{item?.dateStartAt}</div>
                    <div>{item?.dateEndAt}</div>
                    <div>{displayTime(item?.slotStartAt)}</div>
                    <div>{displayTime(item?.slotEndAt)}</div>
                    <div>{item?.requiredQty}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default ViewDrawalModal;
